import { render, staticRenderFns } from "./ChiSiamo.vue?vue&type=template&id=fc10a6d4"
import script from "./ChiSiamo.vue?vue&type=script&lang=js"
export * from "./ChiSiamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports